export default "__VITE_ASSET__BFQd7MUS__"